import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
// import { objectToFormData } from "../../utils";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Close from "../../assets/icons/close.png";
import InvoiceIcon from "../../assets/icons/invoice.svg";
import card_activate from "../../assets/images/card_activate.png";
import success from "../../assets/images/succesasset.png";
import BaseCurrency from "../Common/BaseCurrency";

import {
  ActivateCard,
  Block,
  CardLimitEnable,
  CardsDetails,
  CardsTransfer,
  Replacement,
  SendOTP,
  SetCardPolicy,
  SetPin,
  TopUp,
  UpdateMobileNumber,
  VerifyOTP,
  activate_card,
  block_card,
  card_block_reasons,
  cardsDetails,
  get_card_limit,
  replacement,
  send_otp,
  set_pin,
  update_mobile_number,
} from "./../../actions/cards/cards";
import PageHeader from "./../PageHeader";
import "./card.css";
import CardSettingsAccordion from "./cardSettingsAccordion";
// import KYCDocumentsAccordion from "./kycDocuments";
import { SettingOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Dropdown,
  Input,
  Menu,
  Modal,
  Select,
  Tabs,
  Typography,
  message,
} from "antd";
import TabPane from "antd/lib/tabs/TabPane";
import { ClipLoader, ScaleLoader } from "react-spinners";
import { ErrorModal } from "../../actions/dashboard/dashboard";
import TransferIcon from "../../assets/icons/transfer.svg";
import {
  default as expense,
  default as transit,
} from "../../assets/images/expense.svg";
import eyeClose from "../../assets/images/eye-close.svg";
import eyeOpen from "../../assets/images/eye-open.svg";
import fuel from "../../assets/images/fuel.svg";
import gift from "../../assets/images/gift.svg";
import meal from "../../assets/images/meal.svg";
import reimburse from "../../assets/images/reimbursement.svg";
import { apis } from "../../config/APIs";
import usePayAxios from "../../config/useAxios";
import { hasAccess } from "../../utils";
import { AddCards } from "../Settings/PoliciesLimits/Cards/AddCard";
import BeneficiaryModal from "./BeneficiaryModal";
import CardsSaved from "./CardsSaved";
import TopUpModel from "./TopUpModel";
import TransactionsAccordion from "./transactions";
import TransferModal from "./TransferModal";
import OTPComponent from "../Common/OTPComponent";
import CardDetailsHorizontal from "./CardDetailsHorizontal";

export const walletText = {
  REIMBURSEMENT: "REIMBURSE WALLET",
  GIFT: "GIFT WALLET",
  OFFLINE: "OFFILNE WALLET",
  TRANSIT: "TRANSIT WALLET",
  EXPENSE: "EXPENSE WALLET",
  MEAL: "MEAL WALLET",
  FUEL: "FUEL WALLET",
  REIMBWALLET: "REIMBURSE WALLET",
  GIFTWALLET: "GIFT WALLET",
  OFFLINEWALLET: "OFFLINE WALLET",
  TRANSITWALLET: "TRANSIT WALLET",
  EXPENSEWALLET: "EXPENSE WALLET",
  MEALWALLET: "MEAL WALLET",
  FUELWALLET: "FUEL WALLET",
};

const { Option } = Select;

const { Title } = Typography;

// --- IN-MEMORY BACKUP START ---
// These variables exist in the JS heap. They persist across component unmounts
// (like navigation) but are cleared on page refresh or tab close.
// This avoids using sessionStorage for sensitive data.
let cardDataBackup = null;
let isVerticalBackup = false;
// --- IN-MEMORY BACKUP END ---

const CardDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams(); // Get card ID from URL

  const [kycStatus] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [otpModal, setOTPModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [imgLoading, setImgLoading] = useState(true);
  const [imgError, setImgError] = useState(false);

  const { onCall, data: otpSentData } = usePayAxios({
    api: apis.set_mb_pin,
    method: "post",
  });

  const { onCall: onCallSensitive, data: sensitiveData } = usePayAxios({
    api: apis.get_card_sensitive_data,
    method: "get",
    showSuccessMessage: false,
  });
  const { onCall: onCallProfile, data: profile } = usePayAxios({
    api: apis.profile,
    method: "get",
    showSuccessMessage: false,
  });
  const {
    onCall: onCallUnBlock,
    data: unBlockResponse,
    reset: unBlockResponseReset,
    loading: unBlockResponseLoading,
  } = usePayAxios({
    api: "/api/cards/v1/temporaryBlock",
    method: "post",
  });
  const {
    onCall: onCallSendOTP,
    data: sendOTPResponse,
    reset: sendOTPResponseReset,
    loading: sendOTPResponseLoading,
  } = usePayAxios({
    api: "/api/cards/send_customer_otp",
    method: "post",
  });
  const {
    onCall: onCallActivate,
    data: activateResponse,
    reset: activateResponseReset,
    loading: activateResponseLoading,
  } = usePayAxios({
    api: "/api/cards/activate_v2",
    method: "post",
  });
  const [selectedRow, setSelectedRow] = useState({});
  const [cardDetailsData, setCardDetailsData] = React.useState([]);
  const [editRow, setEditRow] = useState({});
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const [walletData, setWalletData] = React.useState([]);
  const [walletDataForTransfer, setWalletDataTransfer] = React.useState([]);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [blockModel, setBlockModel] = React.useState(false);
  const [topUpModel, setTopUpModel] = React.useState(false);
  const [pinModel, setPinModel] = React.useState(false);
  const [sendOtp, setSendOtp] = React.useState(false);
  const [cardActivation, setCardActivation] = React.useState(false);
  const [updateMobile, setUpdateMobile] = React.useState(false);
  const [activateCardModel, setActivateCardModel] = React.useState(false);
  const [mobile, setMobile] = React.useState("");
  const [mobileError, setMobileError] = useState("");
  const [communicationMobileNumber, setCommunicationMobileNumber] =
    React.useState("");
  const [otp, setOtp] = React.useState("");
  const [cardActivateOTP, setCardActivationOTP] = React.useState("");
  const [blockReason, setBlockReason] = React.useState(null);
  const [replaceModel, setReplaceModel] = React.useState(false);
  const [isEmailVisible, setIsEmailVisible] = useState(false);
  const [isMobileVisible, setIsMobileVisible] = useState(false);
  const [isCommunicationeVisible, setIsCommunicationVisible] = useState(false);
  const [visibleField, setVisibleField] = useState(null);
  const [visibleCField, setVisibleCField] = useState(null);
  const [isTransfer, setIsTransfer] = useState({ open: false, type: "" });
  const [addBeneficiary, setAddBeneficiary] = useState(false);
  const cardsDetailsResponse = useSelector((state) => state.cards.cardsDetails);
  const setCardLimit = useSelector((state) => state.cards.set_card_policy);
  const setPin = useSelector((state) => state.cards.setPin);
  const topUp = useSelector((state) => state.cards.top_up);
  const blockCardResponse = useSelector((state) => state.cards.block);
  const replacementResponse = useSelector((state) => state.cards.replacement);
  const sendOtpRes = useSelector((state) => state.cards.send_otp);
  const verifyOtpRes = useSelector((state) => state.cards.verify_otp);
  const activate_Card = useSelector((state) => state.cards.activate_card);
  const updateMobileNumber = useSelector((state) => state.cards.update_mobile);
  const block_reasons = useSelector(
    (state) => state.cards.block_reasons?.data?.response ?? [],
  );
  const cardTransferCreateData = useSelector(
    (state) => state?.cards?.cardsTransferData?.data,
  );

  const { data: { response: { card_details: cardData = {} } = {} } = {} } =
    cardsDetailsResponse;

  const card_enalbe = useSelector((state) => state.cards.card_enable);

  // Initialize state using location first, then try URL param
  const [card_data, setCardData] = useState(() => {
    if (
      location?.state?.cardData &&
      Object.keys(location.state.cardData).length > 0
    ) {
      return location.state.cardData; // From navigation (full object)
    }

    // Fallback: If navigating directly via URL (refresh), use ID from URL param
    if (id) {
      return { id: id };
    }

    return {};
  });

  const [isVertical, setIsVertical] = useState(() => {
    if (location?.state?.isVertical !== undefined) {
      return location.state.isVertical;
    }
    return false;
  });

  useEffect(() => {
    if (location?.state?.cardData) {
      setCardData(location.state.cardData);
    }
    if (location?.state?.isVertical !== undefined) {
      setIsVertical(location.state.isVertical);
    }
  }, [location?.state]);

  useEffect(() => {
    if (!otpSentData) return;

    if (otpSentData?.status === true) {
      history.push("/set-pin", {
        card_id: card_data?.id,
        card_number: cardData?.card_number,
        pinMeta: otpSentData.response,
        cardData: card_data,
        isVertical: isVertical,
      });
    }
  }, [otpSentData]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setBlockModel(false);
    setSendOtp(false);
    setReplaceModel(false);
    setSelectedRow({});
    setUpdateMobile(false);
    setTopUpModel(false);
    setBlockReason(null);
    setMobile("");
    setMobileError("");
    setOtp("");
  };

  React.useEffect(() => {
    if (card_data?.id) {
      dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch(get_card_limit({ card_id: card_data?.id }));
      dispatch(card_block_reasons({ card_id: card_data?.id }));
      onCallSensitive({
        params: {
          card_id: card_data?.id,
        },
      });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card_data?.id]);

  useEffect(() => {
    onCallProfile({
      params: {
        user_id: localStorage.getItem("user_id"),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (card_data?.id && unBlockResponse?.status == true) {
      dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch(card_block_reasons({ card_id: card_data?.id }));
      unBlockResponseReset();
    } else if (unBlockResponse?.status == false) {
    }
  }, [unBlockResponse]);

  useEffect(() => {
    return () => {
      dispatch({
        type: ActivateCard.RESET,
      });
      dispatch({
        type: SendOTP.RESET,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (card_enalbe?.success) {
      if (card_enalbe?.data?.status)
        dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch({
        type: CardLimitEnable.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card_enalbe]);

  React.useEffect(() => {
    if (setCardLimit?.success && !setCardLimit?.data?.errors) {
      setEditRow({});
      dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch({
        type: SetCardPolicy.RESET,
      });
    }

    if (
      (setCardLimit?.success || !setCardLimit?.success) &&
      setCardLimit?.data?.errors
    ) {
      dispatch({
        type: ErrorModal.SUCCESS,
        payload: {
          open: true,
          errMsg: setCardLimit?.data?.errors,
        },
      });
      dispatch({
        type: SetCardPolicy.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCardLimit]);

  React.useEffect(() => {
    if (updateMobileNumber?.data?.status) {
      setCommunicationMobileNumber(mobile);
      setMobile("");
      dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch({
        type: UpdateMobileNumber.RESET,
      });
    }
    if (updateMobileNumber?.data?.status === false) {
      let errMsg =
        updateMobileNumber?.data?.errors?.message ||
        updateMobileNumber?.data?.message;
      if (
        updateMobileNumber?.data?.errors?.subErrors &&
        updateMobileNumber?.data?.errors?.subErrors.length > 0
      ) {
        errMsg = updateMobileNumber?.data?.errors?.subErrors[0]?.message;
      }
      message.error(<span className="messageText">{errMsg}</span>);
      dispatch({
        type: UpdateMobileNumber.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateMobileNumber]);

  React.useEffect(() => {
    if (blockCardResponse?.data?.status === true) {
      dispatch(cardsDetails({ card_id: card_data?.id }));
      setBlockReason(null);
      dispatch({
        type: Block.RESET,
      });
    }

    if (blockCardResponse?.data?.status === false) {
      dispatch({
        type: ErrorModal.SUCCESS,
        payload: {
          open: true,
          errMsg: blockCardResponse?.data?.errors?.message,
        },
      });
      dispatch({
        type: Block.RESET,
      });
    }
    // eslint-disable-next-line
  }, [blockCardResponse]);

  React.useEffect(() => {
    if (replacementResponse?.data?.status) {
      dispatch(cardsDetails({ card_id: card_data?.id }));
    }

    if (replacementResponse?.data?.status === false) {
      dispatch({
        type: ErrorModal.SUCCESS,
        payload: {
          open: true,
          errMsg: replacementResponse?.data?.errors?.message,
        },
      });
      dispatch({
        type: Replacement.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replacementResponse]);

  React.useEffect(() => {
    if (setPin?.success) {
      window.open(setPin?.data?.response?.set_pin_url, "_blank");
      dispatch({
        type: SetPin.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setPin]);

  React.useEffect(() => {
    if (topUp?.success) {
      message.success(
        <span className="messageText">
          {"Redirected to payment gateway url"}
        </span>,
      );
      window.open(topUp?.data?.response?.url, "_blank");
      dispatch({
        type: TopUp.RESET,
      });
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topUp]);

  React.useEffect(() => {
    if (activate_Card?.data?.status) {
      setOtp("");
      setSendOtp(false);
      setActivateCardModel(true);
      dispatch({
        type: VerifyOTP.RESET,
      });
      if (card_data?.id) {
        dispatch(cardsDetails({ card_id: card_data?.id }));
      }
    } else if (activate_Card?.data?.errors) {
      dispatch({
        type: ActivateCard.RESET,
      });
      setOtp("");
      // setSendOtp(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activate_Card]);

  React.useEffect(() => {
    if (sendOtpRes?.success) {
      setSendOtp(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendOtpRes]);

  React.useEffect(() => {
    if (verifyOtpRes?.data?.status) {
      dispatch({
        type: VerifyOTP.RESET,
      });
      // dispatch(
      //   activate_card({
      //     card_id: cardData?.id,
      //     action_type: "CARDACTIVATION",
      //   })
      // );
      dispatch({
        type: SendOTP.RESET,
      });
    }
    if (verifyOtpRes?.data?.status === false) {
      dispatch({
        type: VerifyOTP.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyOtpRes]);

  React.useEffect(() => {
    const {
      data: {
        response: { card_balances = {}, card_details = {} } = {},
        status = false,
      } = {},
    } = cardsDetailsResponse;
    if (status) {
      setCardDetailsData({ ...card_balances, ...card_details });
      setCommunicationMobileNumber(
        card_details?.data?.communicationMobileNumber || "",
      );
      setWalletData(card_details?.wallets);
      setWalletDataTransfer(card_details?.data?.walletNameAndBalance);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsDetailsResponse]);

  React.useEffect(() => {
    if (cardTransferCreateData?.status == true) {
      dispatch(cardsDetails({ card_id: card_data?.id }));
      dispatch({ type: CardsTransfer?.RESET });
      setIsTransfer({ open: false, type: "" });
    } else if (cardTransferCreateData?.status == false) {
      dispatch({ type: CardsTransfer?.RESET });
    }
  }, [cardTransferCreateData]);

  React.useEffect(() => {
    if (activateResponse?.status === true) {
      activateResponseReset();
      sendOTPResponseReset();
      dispatch(cardsDetails({ card_id: card_data?.id }));
    }
  });

  // function updateKycStatus(status) {
  //   setKycStatus(status);
  // }
  const statues = {
    "Permanent Hotlist": "status_rejected",
  };

  const hideBC = {
    "Permanent Hotlist": true,
    // "Temporary Hotlist": true,
  };

  const hideBCWithTH = {
    "Permanent Hotlist": true,
    "Temporary Hotlist": true,
  };

  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return email; // Return as is if invalid email

    const [firstPart, secondPart] = email.split("@");

    // If first part is too short to mask, return the original email
    if (firstPart.length <= 2) {
      return email;
    }

    // Masking logic for emails with a length greater than 2
    return `${firstPart[0]}${"*".repeat(firstPart.length - 2)}${firstPart.slice(
      -1,
    )}@${secondPart}`;
  };

  // Function to mask the mobile number
  const maskMobile = (mobile) => {
    if (!mobile || mobile.length < 4) return mobile;
    return `******${mobile.slice(-4)}`;
  };

  // Function to mask the card number
  const maskCardNumber = (cardNumber) => {
    if (!cardNumber || cardNumber.length < 16) return cardNumber; // Handle invalid card numbers
    return `XXXX XXXX XXXX ${cardNumber.slice(-4)}`;
  };
  const maskExpiryDate = (expiryDate) => (expiryDate ? "XX/XX" : "");
  const maskCVV = (cvv) => (cvv ? "XXX" : "");
  const ExpiryData = (expiryDate) =>
    expiryDate ? `${expiryDate?.slice(0, 2)}/${expiryDate?.slice(-2)}` : "";
  const formatNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const userData = profile?.response?.profile;

  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === "transit_wallet") {
          setIsTransfer({ open: true, type: "transit_wallet" });
        } else if (key === "bank_account") {
          setIsTransfer({ open: true, type: "bank_account" });
        }
      }}
    >
      <Menu.Item key="transit_wallet">Transfer to Transit Wallet</Menu.Item>
      <Menu.Item key="bank_account" disabled>
        Transfer to Bank Account
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      {isTransfer?.open && (
        <TransferModal
          cardData={card_data}
          isTransfer={isTransfer}
          setIsTransfer={setIsTransfer}
          setAddBeneficiary={setAddBeneficiary}
          walletData={walletDataForTransfer}
        />
      )}
      {addBeneficiary && (
        <BeneficiaryModal
          cardData={card_data}
          setAddBeneficiary={setAddBeneficiary}
          addBeneficiary={addBeneficiary}
          setIsTransfer={setIsTransfer}
        />
      )}

      {isModalVisible && (
        <Modal
          title={
            <Title level={4}>
              {selectedRow?.id ? "Edit" : "Add"} Card Policy &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal lg"
          width={650}
        >
          <AddCards
            handleCancel={handleCancel}
            selectedRow={{ ...selectedRow }}
            from={"card_detail"}
          />
        </Modal>
      )}
      <Modal
        title={<Title level={4}>Confirm &nbsp;</Title>}
        visible={blockModel}
        onCancel={handleCancel}
        footer={[]}
        width={450}
        closable={false}
      >
        <span
          className="cursor"
          onClick={() => {
            setBlockModel(false);
          }}
          style={{ position: "absolute", right: 10, top: 10 }}
        >
          <img src={Close} width={20} alt={"close"} />
        </span>
        <div>
          <Title level={5} className="mb1">
            Are you sure you want to block the card ?
          </Title>
          <Select
            placeholder="Select Reason"
            className="w100"
            value={blockReason}
            onChange={(val) => setBlockReason(val)}
          >
            {Array.isArray(block_reasons) &&
              block_reasons?.map((ele) => {
                return <Option value={ele?.reasons}>{ele?.reasons}</Option>;
              })}
          </Select>
          {block_reasons?.message && (
            <div className="errorMsg">{block_reasons?.message}</div>
          )}
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                onClick={() => {
                  setBlockModel(false);
                  setBlockReason(null);
                }}
              >
                <span>Cancel</span>
              </button>
              <button
                className="active"
                onClick={() => {
                  dispatch(
                    block_card({
                      card_id: card_data?.id,
                      reason: blockReason,
                      action_type: "BLOCKCARD",
                    }),
                  );
                  setBlockModel(false);
                }}
              >
                <span>Block</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <TopUpModel
        topUpModel={topUpModel}
        handleCancel={handleCancel}
        setTopUpModel={setTopUpModel}
        card_data={card_data}
        walletData={walletData}
      />
      <Modal
        title={<Title level={4}>Set Pin &nbsp;</Title>}
        visible={pinModel}
        onCancel={handleCancel}
        footer={[]}
        width={450}
        closable={false}
      >
        <span
          className="cursor"
          onClick={() => {
            setPinModel(false);
          }}
          style={{ position: "absolute", right: 10, top: 10 }}
        >
          <img src={Close} width={20} alt={"close"} />
        </span>
        <div>
          <p className="mb1 message">
            You are leaving the Paycraft application and being redirected to the
            Card Set PIN webpage.Please click on proceed to confirm.
            <br />
            <br />
            If you don't want to continue, Press Cancel.
          </p>
          <p className="note">
            Note:- Browser popup permission should be enabled for the
            redirection.
          </p>
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                onClick={() => {
                  setPinModel(false);
                }}
              >
                <span>Cancel</span>
              </button>
              <button
                className="active"
                onClick={() => {
                  dispatch(
                    set_pin({
                      card_id: card_data?.id,
                    }),
                  );
                  setPinModel(false);
                }}
              >
                <span>Continue</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title={<Title level={4}>Replace Card &nbsp;</Title>}
        visible={replaceModel}
        onCancel={handleCancel}
        footer={[]}
        width={450}
      >
        <div>
          <Title level={5}>
            Are you sure you want to request for a new card ? &nbsp;
          </Title>
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                onClick={() => {
                  setReplaceModel(false);
                }}
              >
                <span>Cancel</span>
              </button>
              <button
                className="active"
                onClick={() => {
                  dispatch(
                    replacement({
                      card_id: card_data?.id,
                      reason: cardData?.data?.cardStatusReason?.toUpperCase(),
                    }),
                  );
                  setReplaceModel(false);
                }}
              >
                <span>Replace</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title={<Title level={4}>Update Communication Number &nbsp;</Title>}
        visible={updateMobile}
        onCancel={handleCancel}
        footer={[]}
        width={500}
      >
        <div>
          <Title level={5}>
            Are you sure you want to update Communication Mobile Number? &nbsp;
          </Title>
          <Input
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(e) => {
              if (
                Number.isNaN(Number(e.target.value)) ||
                e.target.value.length > 10
              ) {
                return;
              }
              setMobile(e.target.value);
            }}
          />
          {mobileError && <span className="error-text">{mobileError}</span>}
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                onClick={() => {
                  setUpdateMobile(false);
                  setMobile("");
                  setMobileError("");
                }}
              >
                <span>Cancel</span>
              </button>
              <button
                className="active update-communication-submit-btn"
                onClick={() => {
                  if (!mobile) {
                    setMobileError("Mobile Number is required");
                    return;
                  }
                  dispatch(
                    update_mobile_number({
                      card_id: card_data?.id,
                      new_mobile_number: mobile,
                    }),
                  );
                  setUpdateMobile(false);
                }}
              >
                <span>Update</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {sendOtp && (
        <Modal
          title={<Title level={4}>Verify OTP &nbsp;</Title>}
          visible={sendOtp}
          onCancel={() => {
            handleCancel();
            setOtp("");
            dispatch({
              type: SendOTP.RESET,
            });
          }}
          footer={[]}
          width={450}
        >
          <div>
            <OTPComponent
              label={"OTP is sent on your registered mobile number"}
              otpExpiryInMinutes={
                sendOtpRes?.data?.response?.otpExpiryInMinutes
              }
              onChange={(val) => {
                setOtp(val);
              }}
              value={otp}
              resendOtp={() => {
                dispatch(
                  send_otp({
                    card_id: card_data?.id,
                    action_type: "CARDACTIVATION",
                  }),
                );
              }}
            />
            {/* <p className="mb1 mt1 message">
            You are leaving the Paycraft application and being redirected to the
            Activate Card webpage after OTP is verification.
            <br />
            <br />
            If you don't want to continue, Press Cancel.
          </p> */}
            {/* <p className="note">
            Note:- Browser popup permission should be enabled for the
            redirection.
          </p> */}
            <div className="top-filter mt1">
              <div className="flt-btns">
                <button
                  onClick={() => {
                    setSendOtp(false);
                    setOtp("");
                    dispatch({
                      type: SendOTP.RESET,
                    });
                  }}
                >
                  <span>Cancel</span>
                </button>
                <button
                  className="active"
                  style={{ background: "#f48c32", fontWeight: "600", fontSize: "1rem" }}
                  disabled={activate_Card?.loading || !otp}
                  onClick={() => {
                    dispatch(
                      activate_card({
                        card_id: card_data?.id,
                        otp,
                        otp_transaction_id: sendOtpRes?.data?.response?.txnId,
                      }),
                    );
                  }}
                >
                  <span>Submit</span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        title={<Title level={4}>Card Activation</Title>}
        visible={cardActivation}
        onCancel={() => {
          setCardActivation(false);
        }}
        footer={[]}
        className="right-alinged-modal lg"
      >
        <div className="card-activation">
          <p className="mb1 mt1 message flex-between">
            <p className="w60">
              Complete Card KYC
              <br />
              <span className="rbi">
                As per RBI guidelines, You need to complete your KYC to active
                the card.
              </span>
            </p>
            <img src={card_activate} alt="" width={100} />
          </p>
          <div className="userContentWrapper mt1">
            <Tabs type="card" size="large" className="custom-tabs">
              <TabPane tab="Overview" key="preferences">
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  {/* Iterate over the fields dynamically */}
                  {[
                    { label: "First Name", value: userData?.first_name },
                    { label: "DOB", value: userData?.dob },
                    { label: "Gender", value: userData?.gender },
                    { label: "Occupation", value: userData?.occupation },
                    {
                      label: "Source Of Income",
                      value: userData?.source_of_income,
                    },
                    {
                      label: "Annual Income",
                      value: userData?.annual_income,
                    },
                    { label: "Nationality", value: userData?.nationality },
                    {
                      label: "Customer Type",
                      value: userData?.customer_type,
                    },
                    {
                      label: "Address Line 1",
                      value: userData?.address_line_1,
                    },
                    {
                      label: "Address Line 2",
                      value: userData?.address_line_2,
                    },
                    {
                      label: "Address Line 3",
                      value: userData?.address_line_3,
                    },
                    { label: "City", value: userData?.city },
                    { label: "Pincode", value: userData?.pincode },
                    { label: "State", value: userData?.state },
                    { label: "Last Name", value: userData?.last_name },
                    {
                      label: "Mobile Number",
                      value: userData?.primary_phone,
                    },
                    { label: "Employee ID", value: userData?.emp_id || "" },
                    { label: "Email", value: userData?.email },
                    { label: "Role", value: userData?.roles?.toString() },
                    {
                      label: "Cost Center",
                      value: userData?.cost_center?.name,
                    },
                    { label: "Project", value: userData?.project?.name },
                    {
                      label: "Political Exposed Person",
                      value: userData?.political_exposed_person,
                    },
                    {
                      label: "FATCA Declaration",
                      value: userData?.fatca_declaration,
                    },
                    {
                      label: "PAN",
                      value: userData?.pan,
                    },
                  ].map((field, index) => (
                    <div
                      key={index}
                      style={{
                        maxWidth: "14rem",
                        minWidth: "13rem",
                      }}
                    >
                      <p>
                        <b>{field.label}</b>
                      </p>
                      <p>{field.value || "-"}</p>
                    </div>
                  ))}

                  {/* Custom Fields */}
                  {userData?.custom_fields &&
                    userData?.custom_fields.map((ele, index) => (
                      <div
                        key={`custom-${index}`}
                        style={{
                          maxWidth: "14rem",
                          minWidth: "13rem",
                        }}
                      >
                        <p>
                          <b>{ele.column_name}</b>
                        </p>
                        <p>{ele.value || "-"}</p>
                      </div>
                    ))}

                  {/* Approvers */}
                  {userData?.approvers && userData?.approvers.length > 0 && (
                    <div
                      style={{
                        maxWidth: "14rem",
                        minWidth: "13rem",
                      }}
                    >
                      <p>
                        <b>Approvers</b>
                      </p>
                      {userData?.approvers.map((ele, index) => (
                        <p
                          key={`approver-${index}`}
                        >{`${ele.name} (${ele.role})`}</p>
                      ))}
                    </div>
                  )}
                </div>
              </TabPane>
            </Tabs>
          </div>
          {/* <ul className="mt1">
            <li>
              <p className="flex-start">
                <img src={aadhar} alt="" width={30} />
                <p>
                  <p className="title">Download Aadhar XML</p>
                  <span>
                    1. Download the Aadhar XML file from the UIDAI site.
                  </span>
                  <span>2. Login and navigate to Offline KYC</span>
                  <span>3. Set the Passcode and download</span>
                </p>
              </p>
              <p className="flex-start">
                <img src={upload_file} alt="" width={30} />
                <p>
                  <p className="title">Upload downloaded file</p>
                  <span>
                    Navigate to bank KYC page to upload the downloaded file and
                    enter details required for KYC.
                  </span>
                </p>
              </p>
              <p className="flex-start">
                <img src={kyc} alt="" width={30} />

                <p>
                  <p className="title">KYC Completed</p>
                  <span>
                    Post completion of KYC process, Your Card will be activated
                    with in 24hrs.
                  </span>
                </p>
              </p>
            </li>
          </ul> */}
        </div>
        <div className="footer-btm">
          <p>
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
            />{" "}
            I have read and agree to{" "}
            {/* <b className="cursor" onClick={() => setIsModalVisible(true)}> */}
            Terms & Conditions
            {/* </b> */}
            {/* <a href='https://drive.google.com/file/d/1VybSmYD9_EOTszFspsCfrBraK9lCL71h/view?usp=sharing' target='_blank'></a> */}
          </p>
          <p className="note">
            Note:- You will be redirected to the web browser for completing the
            KYC process.
          </p>
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                className="active"
                onClick={() => {
                  window.open(cardActivation, "_blank");
                }}
                disabled={!isChecked}
              >
                <span>Open Link</span>
              </button>
              <button
                onClick={() => {
                  setCardActivation(false);
                }}
              >
                <span>Cancel</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={<Title level={4}>Card Activation Status&nbsp;</Title>}
        visible={activateCardModel}
        onCancel={() => {
          setActivateCardModel(false);
          setSendOtp(false);
          dispatch({
            type: ActivateCard.RESET,
          });
        }}
        footer={[]}
        width={500}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {activate_Card?.data?.status ? <img src={success} width={220} /> : ""}
          <br />
          <p
            style={{
              textAlign: "center",
            }}
          >
            {activate_Card?.data?.message ??
              activate_Card?.data?.responseMessage}
          </p>
          {activate_Card?.data?.response?.code === "cms149" ? (
            <p
              style={{
                background: "#AFF5DC",
                padding: 10,
                borderRadius: 10,
                marginTop: 20,
              }}
            >
              Haven't completed the activation ? You can finish it using the
              link shared on the your Registered mobile number or retry after
              48hrs.
            </p>
          ) : (
            ""
          )}

          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                onClick={() => {
                  setActivateCardModel(false);
                  setSendOtp(false);
                  dispatch({
                    type: ActivateCard.RESET,
                  });
                }}
                style={{
                  width: 150,
                  height: 45,
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                  }}
                >
                  Ok
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={location?.state?.pinSuccess}
        onCancel={() => {
          // --- MODIFIED CODE START ---
          // Update location with backup data for smoother experience if user refreshes
          // or navigates within this view later.
          history?.replace(location?.pathname, {
            cardData: card_data,
            isVertical: isVertical,
            pinSuccess: false,
          });
          if (card_data?.id) {
            dispatch(cardsDetails({ card_id: card_data?.id }));  // ✅ refetch
          }
          // --- MODIFIED CODE END ---
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={success}
            alt=""
            style={{
              padding: "2rem 0",
            }}
            width={300}
          />
          <h2 style={{ color: "#333" }}>PIN Set Successful</h2>
          <p></p>
        </div>
      </Modal>

      {otpModal && (
        <Modal
          title={<Title level={4}>Verify OTP &nbsp;</Title>}
          open={otpModal}
          onCancel={() => {
            setOTPModal(false);
            sendOTPResponseReset();
            setCardActivationOTP("");
          }}
          footer={[]}
          width={450}
        >
          <div>
            <OTPComponent
              label={"Verify OTP"}
              onChange={(val) => {
                setCardActivationOTP(val);
              }}
              value={cardActivateOTP}
            />
            <div className="top-filter mt1">
              <div className="flt-btns">
                <button
                  onClick={() => {
                    setOTPModal(false);
                    sendOTPResponseReset();
                    setCardActivationOTP("");
                  }}
                >
                  <span>Cancel</span>
                </button>
                <button
                  className="active"
                  onClick={() => {
                    onCallActivate({
                      card_id: card_data?.id,
                      otp_transaction_id: sendOTPResponse?.response?.txnId,
                      otp: cardActivateOTP,
                    });
                  }}
                  disabled={!cardActivateOTP || activateResponseLoading}
                >
                  {activateResponseLoading ? (
                    <ClipLoader loading={activateResponseLoading} size={10} />
                  ) : (
                    <span>Activate</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Cards`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Cards: "/cards/",
          }}
        />
        {cardData?.replacement_request_placed && (
          <div
            className="success-toast mb2"
            onClick={() => {
              dispatch({
                type: Replacement.RESET,
              });
            }}
          >
            Request for a replacement card is placed successfully.
          </div>
        )}
        {cardsDetailsResponse?.loading && !cardData?.id ? (
          <div className="loader">
            <ScaleLoader />
          </div>
        ) : (
          <div className="detail-card">
            <section className="head">
              <div className="flex-between">
                <div className="v-center">
                  <h3 className="fontWeightBold fontSize2rem">
                    {cardData.employee_details?.name}
                  </h3>
                  <span
                    className={`status ${statues[cardData.status] ? statues[cardData.status] : ""
                      }`}
                  >
                    {cardData.status}
                  </span>
                  {/* {cardData.kyc_flag ? (
                  ""
                ) : ( */}
                  <span className="withoutBgButton ml1 mr1">
                    KYC Status: {cardData.kyc_flag ? cardData.kyc_flag : ""}
                  </span>
                  {/* )} */}
                </div>

                {is_admin ? (
                  <div className="d-flex action-btns">
                    {hasAccess("cards", "write") &&
                      !hideBCWithTH[cardData.status] ? (
                      <button
                        className="more"
                        onClick={() => {
                          setBlockModel((bool) => !bool);
                        }}
                        disabled={blockCardResponse?.loading}
                      >
                        {blockCardResponse?.loading
                          ? "Blocking..."
                          : "Block Card"}
                      </button>
                    ) : (
                      hasAccess("cards", "write") &&
                      is_admin &&
                      !cardDetailsData.replacement_request_placed && (
                        <button
                          className="more"
                          onClick={() => {
                            setReplaceModel((bool) => !bool);
                          }}
                          disabled={replacementResponse?.loading}
                        >
                          Replace Card
                        </button>
                      )
                    )}
                    <span
                      className="close cursor"
                      onClick={() => history.goBack()}
                    >
                      <img src={Close} width={20} alt="" />
                    </span>
                  </div>
                ) : (
                  <div className="d-flex action-btns">
                    {cardData?.status === "Activated" && (
                      <Dropdown overlay={menu} trigger={["click"]}>
                        <button className="transfer-btn">
                          <img
                            src={TransferIcon}
                            alt="transfer"
                            width={20}
                            style={{ marginRight: "0.5rem" }}
                          />
                          <span>Transfer</span>
                        </button>
                      </Dropdown>
                    )}

                    {hasAccess("cards", "write") &&
                      cardData.status === "Issued not active" && (
                        <button
                          className="text-heading small formButton"
                          onClick={() => {
                            dispatch(
                              send_otp({
                                card_id: cardData?.id,
                                action_type: "CARDACTIVATION",
                              }),
                            );
                          }}
                        >
                          Activate Card
                        </button>
                      )}
                    {hasAccess("cards", "write") &&
                      cardData.status === "Temporary Hotlist" && (
                        <button
                          className="approve"
                          onClick={() => {
                            onCallUnBlock({
                              data: {
                                card_id: card_data?.id,
                                block_action: "A",
                              },
                            });
                          }}
                          disabled={unBlockResponseLoading}
                        >
                          {unBlockResponseLoading ? "Unblocking..." : "Unblock"}
                        </button>
                      )}
                    {!hideBC[cardData.status] && (
                      <Dropdown
                        overlay={
                          <Menu>
                            {hasAccess("cards", "write") &&
                              !hideBCWithTH[cardData.status] && (
                                <Menu.Item>
                                  <button
                                    className="text-heading small"
                                    onClick={() => {
                                      // setBlockModel((bool) => !bool);
                                      onCallUnBlock({
                                        data: {
                                          card_id: card_data?.id,
                                          block_action: "THL",
                                        },
                                      });
                                    }}
                                    disabled={unBlockResponseLoading}
                                  >
                                    {unBlockResponseLoading
                                      ? "Blocking..."
                                      : "Block Card"}
                                  </button>
                                </Menu.Item>
                              )}
                            {hasAccess("cards", "write") && (
                              <Menu.Item>
                                <button
                                  className="text-heading small"
                                  onClick={() => {
                                    onCall({
                                      data: {
                                        card_id: card_data?.id,
                                      },
                                    });
                                  }}
                                >
                                  Set / Modify PIN
                                </button>
                              </Menu.Item>
                            )}
                            {hasAccess("cards", "write") &&
                              !hideBCWithTH[cardData.status] && (
                                <Menu.Item
                                  onClick={() => {
                                    setUpdateMobile(true);
                                  }}
                                >
                                  <button className="text-heading small">
                                    Update Communication Number
                                  </button>
                                </Menu.Item>
                              )}
                          </Menu>
                        }
                      >
                        <button
                          className="more"
                          onClick={() => {
                            // setActiveIndex(100);
                          }}
                        >
                          <SettingOutlined />
                        </button>
                      </Dropdown>
                    )}
                    <span
                      className="close cursor"
                      onClick={() => history.goBack()}
                    >
                      <img src={Close} width={20} alt="" />
                    </span>
                  </div>
                )}
              </div>
              <div>
                <span className="duration fontWeight-normal">
                  {isEmailVisible || is_admin
                    ? cardData.employee_details?.email
                    : maskEmail(cardData.employee_details?.email || "")}
                  {!is_admin ? (
                    <span
                      onClick={() => setIsEmailVisible(!isEmailVisible)}
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                    >
                      {isEmailVisible ? (
                        <FaEye color="gray" />
                      ) : (
                        <FaEyeSlash color="gray" />
                      )}
                    </span>
                  ) : null}{" "}
                  {cardData.employee_details?.email && "|"}{" "}
                  {cardData.employee_details?.employee_id}
                </span>
              </div>
            </section>
            <hr />
            <section className="card-info p1 card-info-flex-start card-detail-info">
              <div className="d-flex flex-col w70">
                <div className="d-flex">
                  {isVertical === false && (
                    <CardDetailsHorizontal
                      cardData={cardData}
                      userData={userData}
                      sensitiveData={sensitiveData}
                      isAdmin={is_admin}
                    />
                  )}
                  {isVertical === true && (
                    <div className="card-image-wrapper">
                      {imgLoading && (
                        <div className="card-image-placeholder" aria-hidden>
                          <div
                            style={{
                              width: 160,
                              height: 250,
                              background: "#f5f5f6",
                              borderRadius: 8,
                            }}
                          />
                        </div>
                      )}

                      <img
                        src={
                          imageSrc ||
                          userData?.cards?.data?.imageUrl ||
                          card_data?.imageUrl ||
                          cardData?.imageUrl ||
                          cardData?.data?.imageUrl
                        }
                        alt="Card"
                        className="mt1 card-image"
                        loading="eager"
                        decoding="async"
                        onLoad={(e) => {
                          setImgLoading(false);
                          setImgError(false);
                        }}
                        onError={(e) => {
                          setImgLoading(false);
                          setImgError(true);
                          console.warn(
                            "Card image failed to load:",
                            e.target.src,
                          );
                        }}
                        style={{
                          display: imgLoading ? "none" : "block",
                          borderRadius: 8,
                        }}
                      />

                      {/* fall-back text if image failed */}
                      {imgError && (
                        <div
                          className="card-image-fallback"
                          style={{ color: "#999", marginTop: 8 }}
                        >
                          Card image unavailable
                        </div>
                      )}

                      {/* display name alongside image */}
                      <span className="card-name-vertical">
                        {card_data?.employee_details?.name.toUpperCase()}
                      </span>
                      {/* <span className="card-name-vertical">SIVA SANJAY</span> */}
                    </div>
                  )}
                  <div className="cardProfile d-flex w90">
                    <div className="d-flex flex-col">
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          Card Holder Name
                        </span>
                        <span className="profileCardRightSideName">
                          {cardData?.employee_details?.name
                            ? cardData?.employee_details?.name
                            : cardData.data?.firstName +
                            " " +
                            cardData.data?.lastName}
                        </span>
                      </div>
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          Registered Mobile Number
                        </span>
                        {/* Mobile Number with Eye Icon */}
                        <span
                          className="profileCardRightSideName"
                          style={{ display: "inline", marginTop: "8px" }}
                        >
                          <div>
                            <span style={{ display: "contents" }}>
                              {isMobileVisible || is_admin
                                ? cardData?.mobile_no
                                : maskMobile(cardData?.mobile_no || "-")}
                            </span>
                            {!is_admin ? (
                              <span
                                onClick={() =>
                                  setIsMobileVisible(!isMobileVisible)
                                }
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                  color: "gray",
                                }}
                              >
                                {isMobileVisible ? (
                                  <FaEye color="gray" />
                                ) : (
                                  <FaEyeSlash color="gray" />
                                )}
                              </span>
                            ) : null}
                          </div>
                        </span>
                      </div>
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          Communication Number
                        </span>
                        {/* Mobile Number with Eye Icon */}
                        <span
                          className="profileCardRightSideName"
                          style={{ display: "inline", marginTop: "8px" }}
                        >
                          <div>
                            <span style={{ display: "contents" }}>
                              {isCommunicationeVisible || is_admin
                                ? communicationMobileNumber ||
                                cardData?.data?.communicationMobileNumber
                                : maskMobile(
                                  communicationMobileNumber ||
                                  cardData?.data
                                    ?.communicationMobileNumber ||
                                  "-",
                                )}
                            </span>
                            {!is_admin ? (
                              <span
                                onClick={() =>
                                  setIsCommunicationVisible(
                                    !isCommunicationeVisible,
                                  )
                                }
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                  color: "gray",
                                }}
                              >
                                {isCommunicationeVisible ? (
                                  <FaEye color="gray" />
                                ) : (
                                  <FaEyeSlash color="gray" />
                                )}
                              </span>
                            ) : null}
                          </div>
                        </span>
                      </div>
                      {/* <div className="d-flex item">

                        <span className="profileCardLeftSideTitle">
                          Communication Number
                        </span>
                        <span className="profileCardRightSideName">
                          {cardData.data?.communicationMobileNumber || "-"}
                        </span>
                      </div> */}
                      {isVertical === true && (
                        <>
                          <div className="d-flex item">
                            <span className="profileCardLeftSideTitle">
                              Card number:
                            </span>
                            <span className="profileCardRightSideName">
                              {visibleField === "cardNumber"
                                ? formatNumber(
                                  sensitiveData?.response?.cardNumber || "",
                                )
                                : maskCardNumber(
                                  sensitiveData?.response?.cardNumber ||
                                  card_data?.card_number ||
                                  "-",
                                )}
                            </span>
                            <button
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setVisibleField(
                                  visibleField === "cardNumber"
                                    ? null
                                    : "cardNumber",
                                );
                              }}
                              aria-label="toggle-card-number"
                            >
                              {visibleField === "cardNumber" ? (
                                <FaEye color="gray" />
                              ) : (
                                <FaEyeSlash color="gray" />
                              )}
                            </button>
                          </div>
                          <div className="d-flex item">
                            <span className="profileCardLeftSideTitle">
                              Valid Upto:
                            </span>
                            <span className="profileCardRightSideName">
                              {visibleField === "expiryDate"
                                ? ExpiryData(
                                  sensitiveData?.response?.expiryDate,
                                )
                                : maskExpiryDate(
                                  sensitiveData?.response?.expiryDate ||
                                  card_data?.cardExpiry ||
                                  "",
                                )}
                            </span>
                            <button
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setVisibleField(
                                  visibleField === "expiryDate"
                                    ? null
                                    : "expiryDate",
                                );
                              }}
                              aria-label="toggle-expiry"
                            >
                              {visibleField === "expiryDate" ? (
                                <FaEye color="gray" />
                              ) : (
                                <FaEyeSlash color="gray" />
                              )}
                            </button>
                          </div>
                          <div className="d-flex item">
                            <span className="profileCardLeftSideTitle">
                              CVV:
                            </span>
                            <span className="profileCardRightSideName">
                              {visibleField === "cvv"
                                ? sensitiveData?.response?.cvv || "-"
                                : maskCVV(sensitiveData?.response?.cvv || "")}
                            </span>
                            <button
                              className="icon-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setVisibleField(
                                  visibleField === "cvv" ? null : "cvv",
                                );
                              }}
                              aria-label="toggle-cvv"
                            >
                              {visibleField === "cvv" ? (
                                <FaEye color="gray" />
                              ) : (
                                <FaEyeSlash color="gray" />
                              )}
                            </button>
                          </div>
                        </>
                      )}
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          Card Kit Number
                        </span>
                        <span className="profileCardRightSideName">
                          {cardData.card_reference_no || "-"}
                        </span>
                      </div>
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          Card Type
                        </span>
                        <span className="profileCardRightSideName">
                          {cardData.card_type || "-"}
                        </span>
                      </div>
                      <div className="d-flex item">
                        <span className="profileCardLeftSideTitle">
                          KYC Status
                        </span>
                        <span
                          className={
                            kycStatus === "Verified"
                              ? "profileCardRightSideName colorCodeEF951C verifiedColor"
                              : "profileCardRightSideName colorCodeEF951C"
                          }
                        >
                          {cardData.kyc_flag
                            ? cardData.kyc_flag
                            : "Limited KYC"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {card_data?.card_type === "Gift" ? null : (
                  <CardSettingsAccordion
                    card_ref_number={card_data?.card_reference_no}
                    card_id={card_data?.id}
                    editRow={editRow}
                    setEditRow={setEditRow}
                    channels={cardData?.data?.card_limits?.map(
                      (row) => row.channelType,
                    )}
                    card_limits={cardData?.data?.card_limits}
                    onEdit={() => {
                      let card_limit = cardData?.data?.card_limits?.map(
                        (row) => {
                          let arr = [];
                          if (row.currentDailyLimit) {
                            arr.push({
                              transaction_type: row.channelType,
                              amount: row.currentDailyLimit,
                              frequency: "DAILY",
                            });
                          }
                          if (row.currentMonthlyLimit) {
                            arr.push({
                              transaction_type: row.channelType,
                              amount: row.currentMonthlyLimit,
                              frequency: "MONTHLY",
                            });
                          }
                          if (row.currentAnnualLimit) {
                            arr.push({
                              transaction_type: row.channelType,
                              amount: row.currentAnnualLimit,
                              frequency: "ANNUALLY",
                            });
                          }
                          return arr;
                        },
                      );
                      let arr = [];
                      card_limit.forEach((ele) => {
                        arr = [...arr, ...ele];
                      });

                      setSelectedRow({
                        id: card_data?.id,
                        channel_enabled: [
                          {
                            POS: cardData?.data?.channelType?.includes("POS"),
                          },
                          {
                            ATM: cardData?.data?.channelType?.includes("ATM"),
                          },
                          {
                            ECOM: cardData?.data?.channelType?.includes("ECOM"),
                          },
                        ],
                        assigned_data: [],
                        card_limit: arr,
                      });
                      setIsModalVisible(true);
                    }}
                    onAdd={() => {
                      setIsModalVisible(true);
                    }}
                  />
                )}
                {/* <KYCDocumentsAccordion
                kycStatus={kycStatus}
                updateKycStatus={(status) => updateKycStatus(status)}
              /> */}
                {!is_admin ? (
                  <TransactionsAccordion
                    walletData={walletData}
                    cardData={cardData}
                  />
                ) : null}
                {!is_admin ? <CardsSaved cardData={cardData} /> : null}
              </div>
              <div className="ml1 w30">
                {cardData?.card_type === "Multiwallet" && (
                  <div className="cardProfile mb1">
                    {walletData?.find(
                      (item) =>
                        walletText[item.wallet_name]
                          ?.toLowerCase()
                          ?.includes("transit") ||
                        item.wallet_name?.toLowerCase()?.includes("transit"),
                    ) && (
                        <div className="w100">
                          <span
                            className="expensesAmount"
                            style={{
                              opacity: 0.8,
                              fontSize: "1.3rem",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                            }}
                          >
                            {/* Offline Wallet */}
                            Wallet Top Up
                            {!is_admin && cardData?.status === "Activated" && (
                              <button
                                className="primary-btn"
                                style={{
                                  height: 40,
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "0.9rem",
                                  fontWeight: 500,
                                  padding: "0.5rem 1rem",
                                }}
                                onClick={() => setTopUpModel(true)}
                              >
                                Top Up
                              </button>
                            )}
                          </span>
                          {/* <hr className="mt1 mb1" />
                          {walletData.map((item) =>
                            walletText[item.wallet_name]
                              ?.toLowerCase()
                              ?.includes("transit") ||
                              item.wallet_name
                                ?.toLowerCase()
                                ?.includes("transit") ? (
                              <div key={item.wallet_identifier}>
                                <div
                                  key={item.wallet_identifier}
                                  className="d-flex flex-between mb1 mt1"
                                >
                                  <div>
                                    <img
                                      src={getImages(item.wallet_name)}
                                      alt={"logo"}
                                      width={20}
                                    />
                                    <span className="titleColorCode333333 ml1">
                                      {walletText[item.wallet_name]
                                        ? walletText[item.wallet_name]
                                        : item.wallet_name?.replace(
                                          "WALLET",
                                          ""
                                        ) + " WALLET"}
                                    </span>
                                  </div>
                                  <span className="expensesAmount">
                                    <BaseCurrency /> {item.balance}
                                  </span>
                                </div>
                                <hr />
                              </div>
                            ) : null
                          )} */}
                        </div>
                      )}
                  </div>
                )}
                <div className="cardProfile mt1">
                  <div className="w100">
                    <span
                      className="expensesAmount"
                      style={{ opacity: 0.8, fontSize: "1.3rem" }}
                    >
                      Card Balances
                    </span>
                    <hr className="mt1 mb1" />
                    {walletData.map((item) =>
                      // !["transit", "transitqueue"]?.includes(
                      !["", ""]?.includes(item.wallet_name?.toLowerCase()) ? (
                        <div key={item.wallet_identifier}>
                          <div
                            key={item.wallet_identifier}
                            className="d-flex flex-between mb1 mt1"
                          >
                            <div>
                              <img
                                src={getImages(item.wallet_name)}
                                alt={"logo"}
                                width={20}
                              />
                              <span className="titleColorCode333333 ml1">
                                {walletText[item.wallet_name]
                                  ? walletText[item.wallet_name]
                                  : item.wallet_name?.replace("WALLET", "") +
                                  " WALLET"}
                              </span>
                            </div>
                            <span className="expensesAmount">
                              <BaseCurrency /> {item.balance}
                            </span>
                          </div>
                          <hr />
                        </div>
                      ) : null,
                    )}
                    {cardData?.card_type === "Gift" && (
                      <div className="d-flex flex-between mb1 mt1">
                        <div>
                          <img src={InvoiceIcon} alt={"logo"} />
                          <span className="titleColorCode333333 ml1">
                            {"GIFT WALLET"}
                          </span>
                        </div>
                        <span className="expensesAmount">
                          <BaseCurrency /> {cardData?.balance}
                        </span>
                      </div>
                    )}
                    <div>
                      <div className="d-flex flex-between mb1 mt1">
                        <div>
                          <img src={transit} alt={"logo"} width={20} />
                          <span className="titleColorCode333333 ml1">
                            TRANSIT QUEUE WALLET
                          </span>
                        </div>
                        <span className="expensesAmount">
                          <BaseCurrency /> {cardData?.data?.transitQueue}
                        </span>
                      </div>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
    </>
  );
};

export default CardDetails;

const EyeComponent = ({ image }) => {
  return (
    <div style={{ display: "contents" }}>
      <img src={image} alt="eye image" />
    </div>
  );
};

const getImages = (name) => {
  switch (name) {
    case "TRANSIT":
      return transit;
    case "MEAL":
      return meal;
    case "REIMBURSE":
      return reimburse;
    case "EXPENSE":
      return expense;
    case "GIFT":
      return gift;
    case "FUEL":
      return fuel;
    default:
      return transit;
  }
};
